/**
 * SVG 속성과 inline style 에서 쓰는 색상 상수.
 *
 * SVG 프레젠테이션 속성(`stroke`, `fill`)에는 `var(--x)` 를 신뢰할 수 없으므로
 * 실제 값을 여기에 둔다. `src/styles/global.css` 의 CSS 변수와 **같은 값**을 유지할 것.
 */
export const colors = {
  bg: "#0b0f17",
  card: "#151b26",
  cardBorder: "#222b3a",
  text: "#e6edf3",
  textDim: "#8b98a9",
  buy: "#2ecc71",
  sell: "#e74c3c",
  hold: "#7f8c9a",
  up: "#2ecc71",
  down: "#e74c3c",
  flat: "#7f8c9a",
  accent: "#4c8dff",
  warn: "#f1c40f",
} as const;

export function directionColor(d: string): string {
  return d === "buy" ? colors.buy : d === "sell" ? colors.sell : colors.hold;
}

export function trendColor(t: string): string {
  return t === "up" ? colors.up : t === "down" ? colors.down : colors.flat;
}

/** MACD 히스토그램 부호별 색(값이 없으면 기본 색 유지). */
export function histogramColor(v: number | null | undefined): string | undefined {
  if (v == null) return undefined;
  return v >= 0 ? colors.up : colors.down;
}
